var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkill2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7937_6268)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7937_6268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 0H0V90H90V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7937_6268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.877 49.5353L71.4993 51.5164L67.877 53.4974L65.8959 57.1198L63.9148 53.4974L60.2925 51.5164L63.9148 49.5353L65.8959 45.913L67.877 49.5353Z",
    stroke: "#EEE82C",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1973 24.5226L29.8196 26.5037L26.1973 28.4848L24.2162 32.1071L22.2351 28.4848L18.6128 26.5037L22.2351 24.5226L24.2162 20.9003L26.1973 24.5226Z",
    stroke: "#EEE82C",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9979 45.4079L44.9956 61.3454C44.9954 62.6238 43.9591 63.6601 42.6808 63.6601C41.4186 63.6601 40.389 62.649 40.3662 61.387L39.9376 37.7186M44.9997 45.4079L45.0021 61.3454C45.0022 62.6238 46.0385 63.6601 47.3169 63.6601C48.579 63.6601 49.6086 62.649 49.6315 61.3872L50.0615 37.7186M36.6241 69.4312V63.6601H53.3753V69.4312M44.7956 23.5838H47.1622C47.6187 23.5838 47.9922 23.2103 47.9922 22.7538V18.8401C47.9922 17.3138 46.7434 16.065 45.2172 16.065H44.7956C43.2694 16.065 42.0205 17.3138 42.0205 18.8401V20.8087C42.0205 22.3349 43.2694 23.5838 44.7956 23.5838ZM44.9997 35.0312L39.784 37.7995C38.3241 38.5744 36.5642 37.5161 36.5642 35.8632V31.4224C36.5642 29.0497 38.3296 27.0304 40.6864 26.7547C42.1217 26.5867 43.5608 26.5037 44.9997 26.5037C46.4363 26.5037 47.8729 26.5865 49.3059 26.7539C51.664 27.0299 53.4352 29.0459 53.4352 31.4224V35.8627C53.4352 37.5163 51.675 38.574 50.2163 37.7996L44.9997 35.0312Z",
    stroke: "#00A0AE",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4456 73.8214H33.554V69.4597H56.4456V73.8214Z",
    stroke: "#EEE82C",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7937_6268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill2);
export default __webpack_public_path__ + "static/media/skill2.73ae31b369558a797e299e0ec9a3f4e5.svg";
export { ForwardRef as ReactComponent };